import dayjs from "dayjs";

import { getTravelerTypeOfAge } from "@/features/travellers/utils/transformTraveler";

/**
 * Gets the traveller age based on travel date
 * @param birthDate - Traveller's birth date
 * @param travelDate - Date of travel (departure/check-in)
 * @returns The age of traveller at the travel date
 */
export const getTravellerAgeAtTravelDate = (
  birthDate: string,
  travelDate: Date,
): number => {
  const birthDayjs = dayjs(birthDate);
  const travelDayjs = dayjs(travelDate);
  return travelDayjs.diff(birthDayjs, "year");
};

/**
 * Gets the traveller type based on age at travel date
 * @param birthDate - Traveller's birth date
 * @param travelDate - Date of travel (departure/check-in)
 * @returns The traveller type ("adult" | "child" | "infant")
 */
export const getTravellerTypeAtTravelDate = (
  birthDate: string,
  travelDate: Date,
): "adult" | "child" | "infant" => {
  const ageAtTravel = getTravellerAgeAtTravelDate(birthDate, travelDate);
  return getTravelerTypeOfAge(ageAtTravel);
};
